<template>
  <el-popover
    placement="bottom"
    v-model="popoverVisible"
    width="270"
    trigger="click">
    <el-row>
      <el-radio-group size="small" v-model="internalValue">
        <el-radio-button v-for="status in Object.values($options.DOCUTAX_SUBMISSION_STATUS)" :label="status" :key="status">
          {{$options.DOCUTAX_SUBMISSION_STATUS_DESCRIPTION_MAP[status]}}
        </el-radio-button>
      </el-radio-group>
    </el-row>
    <el-row class="mt-3 align-right">
      <el-button :disabled="saving" class="ml-3" size="small" type="text" @click="onCancel">Cancel</el-button>
      <el-button :disabled="saving" size="small" type="primary" @click="onSave">Save</el-button>
    </el-row>

    <docutax-submission-status-tag v-loading="saving" slot="reference" class="editable-tag" :status="value" />
  </el-popover>
</template>

<script>
import DocutaxSubmissionStatusTag from './DocutaxSubmissionStatus.vue';
import { DOCUTAX_SUBMISSION_STATUS, DOCUTAX_SUBMISSION_STATUS_DESCRIPTION_MAP } from '@/enum/DocutaxSubmissionStatus';

export default {
  components: {
    DocutaxSubmissionStatusTag,
  },
  DOCUTAX_SUBMISSION_STATUS,
  DOCUTAX_SUBMISSION_STATUS_DESCRIPTION_MAP,
  props: {
    value: {
      type: String,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popoverVisible: false,
      internalValue: undefined,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.internalValue = value;
        this.popoverVisible = false;
      },
    },
  },
  methods: {
    onSave() {
      this.$emit('update:value', this.internalValue);
    },
    onCancel() {
      this.internalValue = this.value;
      this.popoverVisible = false;
    },
  },
};

</script>
